import type { ReactNode } from 'react'
import type { TourAnchor } from '~/helpers/tour/anchors'
import { useId } from 'react'
import { tourAnchor } from '~/helpers/tour/anchors'

type ProfileSectionProps = {
  title: string
  anchor: TourAnchor
  action?: ReactNode
  children: ReactNode
}

/** Un bloc de la fiche apprenant (#242) : une carte titrée, repérée par la visite guidée. */
function ProfileSection({ title, anchor, action, children }: ProfileSectionProps) {
  const titleId = useId()

  // Titrée : la section devient une région nommée, atteignable au lecteur d'écran.
  return (
    <section aria-labelledby={titleId} className="rounded-2xl border border-border bg-card p-5 shadow-sm" {...tourAnchor(anchor)}>
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 id={titleId} className="text-lg font-semibold">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  )
}

export default ProfileSection
